import { z } from 'zod';
import { Id, IsoDateTime } from './common.js';

export const ChannelType = z.enum(['whatsapp', 'instagram', 'facebook']);
export type ChannelType = z.infer<typeof ChannelType>;

export const ChannelStatus = z.enum(['active', 'inactive', 'token_expired', 'revoked']);

export const Channel = z.object({
  channel_id: Id,
  merchant_id: Id,
  fiwano_channel_id: z.string(),
  channel_type: ChannelType,
  display_name: z.string(),
  // type-specific identifiers
  phone_number_id: z.string().nullable().optional(),
  phone_number: z.string().nullable().optional(),
  waba_id: z.string().nullable().optional(),
  ig_account_id: z.string().nullable().optional(),
  ig_username: z.string().nullable().optional(),
  page_id: z.string().nullable().optional(),
  // configuration
  is_active: z.boolean(),
  status: ChannelStatus,
  webhook_secret_present: z.boolean(),
  connected_at: IsoDateTime,
  token_expires_at: IsoDateTime.nullable(),
});
export type Channel = z.infer<typeof Channel>;

export const MessageType = z.enum([
  'text',
  'image',
  'audio',
  'voice',
  'video',
  'document',
  'sticker',
  'unsupported',
]);
export type MessageType = z.infer<typeof MessageType>;

export const TextLengthLimits: Record<ChannelType, number> = {
  whatsapp: 4096,
  instagram: 1000,
  facebook: 2000,
} as const;
